import {store} from "../../../store/store";

store.applicant = {
    _this: null,
    navName: '预约',
}
export default {
    name: "applicant",
    data() {
        store.applicant._this = this;
        return {
            ...store.applicant,
        }
    },
}